import React from 'react';
import ProductForm from '../components/admin/ProductForm';
import { useNavigate } from 'react-router-dom';

const AddProductPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ProductForm
      onSubmitSuccess={() => navigate('/products')}
    />
  );
};

export default AddProductPage;
